export default __webpack_public_path__ + "static/guide-1e788b67693b4c384a76fb83629d636d.png";